import debugLogScriptName from '@/debug-log-script-name'

$(function() {
  $('body').on('bless', function(e) {
    const $target = $(e.target)
    const $verify = $target.is('[data-verify-code]')
      ? $target
      : $target.find('[data-verify-code]')
    debugLogScriptName($verify, 'verify-code.js') // DEBUG
    $verify.on('keyup', 'input[name="code"]', function(e) {
      var $el = $(e.delegateTarget),
        $button = $el.find('.button--verify'),
        $response = $el.find('.response'),
        $submit = $el.parents('form').find('[type="submit"]')
      $response.addClass('response--hidden')
      $submit.prop('disabled', true)
      $button
        .prop('disabled', false)
        .text('Verify')
        .show()
    })

    $verify.on('click', 'button', function(e) {
      var $button = $(this)
          .prop('disabled', true)
          .text('Please wait...'),
        $el = $(e.delegateTarget),
        $code = $el.find('[name="code"]'),
        $response = $el.find('.response'),
        $submit = $el.parents('form').find('[type="submit"]')

      $.ajax({
        method: 'GET',
        url: $el.attr('data-verify-code'),
        data: { code: $code.val() },
        dataType: 'json',
      }).done(function(data) {
        var responseClass = data.success ? 'success' : 'error'

        $response
          .removeClass('response--hidden response--success response--error')
          .text(data.text)
          .addClass('response--' + responseClass)

        if (data.success) {
          $submit.prop('disabled', false)
          $button.hide()
        } else {
          $submit.prop('disabled', true)
          $button
            .prop('disabled', false)
            .text('Verify')
            .show()
        }
      })
    })
  })
})
